// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Variables
   ============================================ */
/* ============================================
   Manifesto theme (palette "necrologio/manifesto" per le pagine
   pubbliche: home e dettaglio necrologio). Scoped tramite custom
   properties per non toccare il tema Ant Design usato nell'area
   agenzia/admin.
   ============================================ */
:root {
  --od-bg: #f6f1e7;
  --od-surface: #fffdf9;
  --od-surface-sunken: #efe7d8;
  --od-ink: #26211a;
  --od-ink-muted: #756b58;
  --od-ink-faint: #a89b81;
  --od-accent: #9c7a35;
  --od-accent-strong: #7c5f26;
  --od-border: #e4d9c1;
  --od-border-strong: #d5c6a2;
  --od-shadow: 0 1px 2px rgba(38, 33, 26, 0.06), 0 8px 24px -16px rgba(38, 33, 26, 0.18);
  --od-font-display: 'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, serif;
}
/* ============================================
   Reset & Base
   ============================================ */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  color: #333;
  background-color: #f5f5f5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#root {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
/* ============================================
   Typography
   ============================================ */
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 16px;
  font-weight: 500;
  line-height: 1.2;
}
h1 {
  font-size: 32px;
}
h2 {
  font-size: 28px;
}
h3 {
  font-size: 24px;
}
h4 {
  font-size: 20px;
}
h5 {
  font-size: 18px;
}
h6 {
  font-size: 16px;
}
p {
  margin-bottom: 16px;
  line-height: 1.6;
}
a {
  color: #1890ff;
  text-decoration: none;
  transition: color 0.3s ease;
}
a:hover {
  color: #4ba9ff;
}
/* ============================================
   Utility Classes
   ============================================ */
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.text-primary {
  color: #1890ff;
}
.text-success {
  color: #52c41a;
}
.text-warning {
  color: #faad14;
}
.text-error {
  color: #f5222d;
}
.text-muted {
  color: #999;
}
.font-bold {
  font-weight: 600;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-light {
  font-weight: 300;
}
/* Spacing */
.m-0 {
  margin: 0;
}
.mt-1 {
  margin-top: 4px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-3 {
  margin-top: 16px;
}
.mt-4 {
  margin-top: 24px;
}
.mt-5 {
  margin-top: 32px;
}
.mb-1 {
  margin-bottom: 4px;
}
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 16px;
}
.mb-4 {
  margin-bottom: 24px;
}
.mb-5 {
  margin-bottom: 32px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-2 {
  margin-left: 8px;
}
.ml-3 {
  margin-left: 16px;
}
.mr-1 {
  margin-right: 4px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 16px;
}
.p-0 {
  padding: 0;
}
.p-1 {
  padding: 4px;
}
.p-2 {
  padding: 8px;
}
.p-3 {
  padding: 16px;
}
.p-4 {
  padding: 24px;
}
.p-5 {
  padding: 32px;
}
/* Flex */
.d-flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.align-start {
  align-items: flex-start;
}
.align-center {
  align-items: center;
}
.align-end {
  align-items: flex-end;
}
.flex-grow-1 {
  flex-grow: 1;
}
/* Container */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}
@media (min-width: 768px) {
  .container {
    padding: 0 24px;
  }
}
.container-fluid {
  width: 100%;
  padding: 0 16px;
}
@media (min-width: 768px) {
  .container-fluid {
    padding: 0 24px;
  }
}
/* ============================================
   Custom Scrollbar
   ============================================ */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
/* ============================================
   Ant Design Overrides
   ============================================ */
.ant-btn-primary {
  background-color: #1890ff;
}
.ant-layout {
  background: #f5f5f5;
}
.ant-card {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}
.ant-card-head {
  border-bottom: 1px solid #f0f0f0;
}
.ant-modal-content {
  border-radius: 8px;
}
.ant-modal-header {
  border-radius: 8px 8px 0 0;
}
.ant-modal-header .ant-modal-title {
  padding-right: 28px;
}
/* ============================================
   Animations
   ============================================ */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.fade-in {
  animation: fadeIn 0.3s ease;
}
.slide-up {
  animation: slideUp 0.3s ease;
}
/* ============================================
   Print Styles
   ============================================ */
@media print {
  .no-print {
    display: none !important;
  }
  body {
    background: white;
  }
  .ant-layout {
    background: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.less"],"names":[],"mappings":"AAAA;;iDAEiD;AACjD;;;;;iDAKiD;AAiCjD;EACI,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,sFAAA;EACA,mFAAA;AA/BJ;AACA;;iDAEiD;AAkCjD;EACI,SAAA;EACA,UAAA;EACA,sBAAA;AAhCJ;AAmCA;;EAEI,YAAA;EACA,gHAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,mCAAA;EACA,kCAAA;AAjCJ;AAoCA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAlCJ;AACA;;iDAEiD;AAqCjD;;;;;;EAMI,mBAAA;EACA,gBAAA;EACA,gBAAA;AAnCJ;AAsCA;EACI,eAAA;AApCJ;AAuCA;EACI,eAAA;AArCJ;AAwCA;EACI,eAAA;AAtCJ;AAyCA;EACI,eAAA;AAvCJ;AA0CA;EACI,eAAA;AAxCJ;AA2CA;EACI,eAAA;AAzCJ;AA4CA;EACI,mBAAA;EACA,gBAAA;AA1CJ;AA6CA;EACI,cAAA;EACA,qBAAA;EACA,2BAAA;AA3CJ;AA6CI;EACI,cAAA;AA3CR;AACA;;iDAEiD;AA+CjD;EACI,kBAAA;AA7CJ;AAgDA;EACI,iBAAA;AA9CJ;AAiDA;EACI,gBAAA;AA/CJ;AAkDA;EACI,cAAA;AAhDJ;AAmDA;EACI,cAAA;AAjDJ;AAoDA;EACI,cAAA;AAlDJ;AAqDA;EACI,cAAA;AAnDJ;AAsDA;EACI,WAAA;AApDJ;AAuDA;EACI,gBAAA;AArDJ;AAwDA;EACI,gBAAA;AAtDJ;AAyDA;EACI,gBAAA;AAvDJ;AA0DA;EACI,gBAAA;AAxDJ;AACA,YAAY;AA2DZ;EACI,SAAA;AAzDJ;AA4DA;EACI,eAAA;AA1DJ;AA6DA;EACI,eAAA;AA3DJ;AA8DA;EACI,gBAAA;AA5DJ;AA+DA;EACI,gBAAA;AA7DJ;AAgEA;EACI,gBAAA;AA9DJ;AAiEA;EACI,kBAAA;AA/DJ;AAkEA;EACI,kBAAA;AAhEJ;AAmEA;EACI,mBAAA;AAjEJ;AAoEA;EACI,mBAAA;AAlEJ;AAqEA;EACI,mBAAA;AAnEJ;AAsEA;EACI,gBAAA;AApEJ;AAuEA;EACI,gBAAA;AArEJ;AAwEA;EACI,iBAAA;AAtEJ;AAyEA;EACI,iBAAA;AAvEJ;AA0EA;EACI,iBAAA;AAxEJ;AA2EA;EACI,kBAAA;AAzEJ;AA4EA;EACI,UAAA;AA1EJ;AA6EA;EACI,YAAA;AA3EJ;AA8EA;EACI,YAAA;AA5EJ;AA+EA;EACI,aAAA;AA7EJ;AAgFA;EACI,aAAA;AA9EJ;AAiFA;EACI,aAAA;AA/EJ;AACA,SAAS;AAkFT;EACI,aAAA;AAhFJ;AAmFA;EACI,sBAAA;AAjFJ;AAoFA;EACI,eAAA;AAlFJ;AAqFA;EACI,2BAAA;AAnFJ;AAsFA;EACI,uBAAA;AApFJ;AAuFA;EACI,yBAAA;AArFJ;AAwFA;EACI,8BAAA;AAtFJ;AAyFA;EACI,6BAAA;AAvFJ;AA0FA;EACI,uBAAA;AAxFJ;AA2FA;EACI,mBAAA;AAzFJ;AA4FA;EACI,qBAAA;AA1FJ;AA6FA;EACI,YAAA;AA3FJ;AACA,cAAc;AA8Fd;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA5FJ;AA8FI;EAAA;IACI,eAAA;EA3FN;AACF;AA8FA;EACI,WAAA;EACA,eAAA;AA5FJ;AA8FI;EAAA;IACI,eAAA;EA3FN;AACF;AACA;;iDAEiD;AA8FjD;EACI,UAAA;EACA,WAAA;AA5FJ;AA+FA;EACI,mBAAA;EACA,kBAAA;AA7FJ;AAgGA;EACI,mBAAA;EACA,kBAAA;AA9FJ;AAgGI;EACI,mBAAA;AA9FR;AACA;;iDAEiD;AAkGjD;EACI,yBAAA;AAhGJ;AAmGA;EACI,mBAAA;AAjGJ;AAoGA;EACI,kBAAA;EACA,wCAAA;AAlGJ;AAqGA;EACI,gCAAA;AAnGJ;AAsGA;EACI,kBAAA;AApGJ;AAuGA;EACI,0BAAA;AArGJ;AAoGA;EAMQ,mBAAA;AAvGR;AACA;;iDAEiD;AA2GjD;EACI;IACI,UAAA;EAzGN;EA4GE;IACI,UAAA;EA1GN;AACF;AA6GA;EACI;IACI,2BAAA;IACA,UAAA;EA3GN;EA8GE;IACI,wBAAA;IACA,UAAA;EA5GN;AACF;AA+GA;EACI;IACI,uBAAA;EA7GN;EAgHE;IACI,yBAAA;EA9GN;AACF;AAiHA;EACI,2BAAA;AA/GJ;AAkHA;EACI,4BAAA;AAhHJ;AACA;;iDAEiD;AAmHjD;EACI;IACI,wBAAA;EAjHN;EAoHE;IACI,iBAAA;EAlHN;EAqHE;IACI,iBAAA;EAnHN;AACF","sourcesContent":["/* ============================================\n   Variables\n   ============================================ */\n@primary-color: #1890ff;\n@success-color: #52c41a;\n@warning-color: #faad14;\n@error-color: #f5222d;\n\n@font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n@font-size-base: 14px;\n@font-size-lg: 16px;\n@font-size-sm: 12px;\n\n@border-radius-base: 6px;\n@border-radius-sm: 4px;\n@border-radius-lg: 8px;\n\n@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);\n@box-shadow-sm: 0 1px 4px rgba(0, 0, 0, 0.1);\n@box-shadow-lg: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n@screen-xs: 480px;\n@screen-sm: 576px;\n@screen-md: 768px;\n@screen-lg: 992px;\n@screen-xl: 1200px;\n@screen-xxl: 1600px;\n\n@spacing-xs: 4px;\n@spacing-sm: 8px;\n@spacing-md: 16px;\n@spacing-lg: 24px;\n@spacing-xl: 32px;\n@spacing-xxl: 48px;\n\n/* ============================================\n   Manifesto theme (palette \"necrologio/manifesto\" per le pagine\n   pubbliche: home e dettaglio necrologio). Scoped tramite custom\n   properties per non toccare il tema Ant Design usato nell'area\n   agenzia/admin.\n   ============================================ */\n:root {\n    --od-bg: #f6f1e7;\n    --od-surface: #fffdf9;\n    --od-surface-sunken: #efe7d8;\n    --od-ink: #26211a;\n    --od-ink-muted: #756b58;\n    --od-ink-faint: #a89b81;\n    --od-accent: #9c7a35;\n    --od-accent-strong: #7c5f26;\n    --od-border: #e4d9c1;\n    --od-border-strong: #d5c6a2;\n    --od-shadow: 0 1px 2px rgba(38, 33, 26, 0.06), 0 8px 24px -16px rgba(38, 33, 26, 0.18);\n    --od-font-display: 'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, serif;\n}\n\n/* ============================================\n   Reset & Base\n   ============================================ */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n    height: 100%;\n    font-family: @font-family;\n    font-size: @font-size-base;\n    color: #333;\n    background-color: #f5f5f5;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n/* ============================================\n   Typography\n   ============================================ */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-bottom: @spacing-md;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\nh1 {\n    font-size: 32px;\n}\n\nh2 {\n    font-size: 28px;\n}\n\nh3 {\n    font-size: 24px;\n}\n\nh4 {\n    font-size: 20px;\n}\n\nh5 {\n    font-size: 18px;\n}\n\nh6 {\n    font-size: 16px;\n}\n\np {\n    margin-bottom: @spacing-md;\n    line-height: 1.6;\n}\n\na {\n    color: @primary-color;\n    text-decoration: none;\n    transition: color 0.3s ease;\n\n    &:hover {\n        color: lighten(@primary-color, 10%);\n    }\n}\n\n/* ============================================\n   Utility Classes\n   ============================================ */\n.text-center {\n    text-align: center;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.text-primary {\n    color: @primary-color;\n}\n\n.text-success {\n    color: @success-color;\n}\n\n.text-warning {\n    color: @warning-color;\n}\n\n.text-error {\n    color: @error-color;\n}\n\n.text-muted {\n    color: #999;\n}\n\n.font-bold {\n    font-weight: 600;\n}\n\n.font-medium {\n    font-weight: 500;\n}\n\n.font-normal {\n    font-weight: 400;\n}\n\n.font-light {\n    font-weight: 300;\n}\n\n/* Spacing */\n.m-0 {\n    margin: 0;\n}\n\n.mt-1 {\n    margin-top: @spacing-xs;\n}\n\n.mt-2 {\n    margin-top: @spacing-sm;\n}\n\n.mt-3 {\n    margin-top: @spacing-md;\n}\n\n.mt-4 {\n    margin-top: @spacing-lg;\n}\n\n.mt-5 {\n    margin-top: @spacing-xl;\n}\n\n.mb-1 {\n    margin-bottom: @spacing-xs;\n}\n\n.mb-2 {\n    margin-bottom: @spacing-sm;\n}\n\n.mb-3 {\n    margin-bottom: @spacing-md;\n}\n\n.mb-4 {\n    margin-bottom: @spacing-lg;\n}\n\n.mb-5 {\n    margin-bottom: @spacing-xl;\n}\n\n.ml-1 {\n    margin-left: @spacing-xs;\n}\n\n.ml-2 {\n    margin-left: @spacing-sm;\n}\n\n.ml-3 {\n    margin-left: @spacing-md;\n}\n\n.mr-1 {\n    margin-right: @spacing-xs;\n}\n\n.mr-2 {\n    margin-right: @spacing-sm;\n}\n\n.mr-3 {\n    margin-right: @spacing-md;\n}\n\n.p-0 {\n    padding: 0;\n}\n\n.p-1 {\n    padding: @spacing-xs;\n}\n\n.p-2 {\n    padding: @spacing-sm;\n}\n\n.p-3 {\n    padding: @spacing-md;\n}\n\n.p-4 {\n    padding: @spacing-lg;\n}\n\n.p-5 {\n    padding: @spacing-xl;\n}\n\n/* Flex */\n.d-flex {\n    display: flex;\n}\n\n.flex-column {\n    flex-direction: column;\n}\n\n.flex-wrap {\n    flex-wrap: wrap;\n}\n\n.justify-start {\n    justify-content: flex-start;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.justify-end {\n    justify-content: flex-end;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.justify-around {\n    justify-content: space-around;\n}\n\n.align-start {\n    align-items: flex-start;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.align-end {\n    align-items: flex-end;\n}\n\n.flex-grow-1 {\n    flex-grow: 1;\n}\n\n/* Container */\n.container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 @spacing-md;\n\n    @media (min-width: @screen-md) {\n        padding: 0 @spacing-lg;\n    }\n}\n\n.container-fluid {\n    width: 100%;\n    padding: 0 @spacing-md;\n\n    @media (min-width: @screen-md) {\n        padding: 0 @spacing-lg;\n    }\n}\n\n/* ============================================\n   Custom Scrollbar\n   ============================================ */\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n\n    &:hover {\n        background: #a8a8a8;\n    }\n}\n\n/* ============================================\n   Ant Design Overrides\n   ============================================ */\n.ant-btn-primary {\n    background-color: @primary-color;\n}\n\n.ant-layout {\n    background: #f5f5f5;\n}\n\n.ant-card {\n    border-radius: @border-radius-lg;\n    box-shadow: @box-shadow-sm;\n}\n\n.ant-card-head {\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.ant-modal-content {\n    border-radius: @border-radius-lg;\n}\n\n.ant-modal-header {\n    border-radius: @border-radius-lg @border-radius-lg 0 0;\n\n    // Evita che il titolo, quando va a capo su schermi stretti, finisca\n    // sotto la X di chiusura (posizionata in assoluto in alto a destra).\n    .ant-modal-title {\n        padding-right: 28px;\n    }\n}\n\n/* ============================================\n   Animations\n   ============================================ */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.fade-in {\n    animation: fadeIn 0.3s ease;\n}\n\n.slide-up {\n    animation: slideUp 0.3s ease;\n}\n\n/* ============================================\n   Print Styles\n   ============================================ */\n@media print {\n    .no-print {\n        display: none !important;\n    }\n\n    body {\n        background: white;\n    }\n\n    .ant-layout {\n        background: white;\n    }\n}\n@primary-color: #1890ff;@border-radius-base: 8px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
